var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('important',{tag:"div",attrs:{"dataAll":{current:_vm.current.components.simple}}})}
var staticRenderFns = []

export { render, staticRenderFns }